import { render, staticRenderFns } from "./UserPublicInfoEdit.vue?vue&type=template&id=3a78cdd6&"
import script from "./UserPublicInfoEdit.vue?vue&type=script&lang=js&"
export * from "./UserPublicInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserPublicInfoEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports